import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export default function FAQSection({ items, title = 'Frequently Asked Questions' }) {
  return (
    <section className="py-24 md:py-32 bg-[#F4F4F5]" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#002FA7] mb-3">FAQ</p>
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight text-[#09090B] leading-tight">
              {title}
            </h2>
            <p className="text-base text-zinc-600 mt-4 font-body">
              Have more questions? Our team is ready to help. Contact us anytime for personalized assistance.
            </p>
          </div>
          <div className="md:col-span-8">
            <Accordion type="single" collapsible className="space-y-0">
              {items.map((faq, idx) => (
                <AccordionItem
                  key={idx}
                  value={`faq-${idx}`}
                  className="border border-[#E4E4E7] bg-white px-6 mb-0 border-b-0 last:border-b"
                >
                  <AccordionTrigger
                    className="font-heading font-bold text-[#09090B] text-left py-5 hover:no-underline"
                    data-testid={`faq-trigger-${idx}`}
                  >
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-zinc-600 font-body leading-relaxed pb-5" data-testid={`faq-content-${idx}`}>
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
